import { FC } from 'react';

import { useProcessedWorkStore } from '../../studentApp/hooks';

import { MobileBottomBanner } from './banner/bottomBanner';
import { ExamButtons } from './banner/examButtons';
import { MobileBanner } from './banner/mobileBanner';
import { SquaresAndProblem } from './squares/squaresAndProblem';

export const MobileLayout: FC = () => {
  const isTesting = useProcessedWorkStore().isTesting;

  return (
    <>
      <SquaresAndProblem />
      <div className="sticky-banner">
        <MobileBanner />
        {isTesting && <ExamButtons />}
      </div>
      <div className="sticky-bottom-banner">
        <MobileBottomBanner />
      </div>
    </>
  );
};
